export const backend = {
  "restUrl": "/maja/backend/rest",
  "restUrlSY": "/maja/backend/sy/rest",
  "restUrlDI": "/maja/backend/di/rest",
  "restUrlPK": "/maja/backend/pro/rest",
  "restUrlPkProxy": "/maja/backend/promap-proxy",
  "restUrlVFZE": "/maja/backend/vfze/vfze/v1",
  "restUrlSV": "/maja/backend/templates",
  "restUrlDOSS": "/maja/backend/doss", // @TODO DOSS
  "restUrlSETTINGS": "/maja/backend/users",
  "restUrlConfig": "/maja/backend/configuration",
  "geoserverUrl": "/maja/geoserver",
  "geoserverDIUrl": "/maja/geoserver"
};
